/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_Dim_Crawler_AccessInputs */

const en_directory_detail_signals_geo_dim_crawler_access = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Crawler_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI crawler access`)
};

const zh_directory_detail_signals_geo_dim_crawler_access = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Crawler_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 爬虫访问`)
};

/**
* | output |
* | --- |
* | "AI crawler access" |
*
* @param {Directory_Detail_Signals_Geo_Dim_Crawler_AccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_dim_crawler_access = /** @type {((inputs?: Directory_Detail_Signals_Geo_Dim_Crawler_AccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_Dim_Crawler_AccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_dim_crawler_access(inputs)
	return zh_directory_detail_signals_geo_dim_crawler_access(inputs)
});
export { directory_detail_signals_geo_dim_crawler_access as "directory.detail.signals.geo_dim.crawler_access" }